export const OPEN_COOKIE_SETTINGS_EVENT = 'vansite:open-cookie-settings';

export const openCookieSettings = () => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
};
